import React from "react";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const NodeTypeSelector = ({ nodeType, setNodeType }) => {
  return (
    <FormControl fullWidth margin="normal">
      <InputLabel>Tipo de Nó</InputLabel>
      <Select value={nodeType} onChange={(e) => setNodeType(e.target.value)}>
        <MenuItem value="entrada">Entrada</MenuItem>
        <MenuItem value="decisao">Decisão</MenuItem>
        <MenuItem value="acao">Ação</MenuItem>
      </Select>
    </FormControl>
  );
};

export default NodeTypeSelector;
